import { Check, X } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PageHeader, Section, CTABanner } from "@/components/blocks";

const INCLUDED = [
  "Understanding your family's routine, values and care needs",
  "Introducing professionally prepared nannies suited to your household",
  "Supporting live-in and live-out arrangements across the Emirates",
  "Matching for newborns, toddlers, school-age children and beyond",
  "A calm, personal process from first request to introduction",
];

const NOT_INCLUDED = [
  "Cleaning or general maid services",
  "Visa, immigration or sponsorship processing",
  "Payroll or salary administration",
  "Public candidate listings or self-service booking",
];

export default function Services() {
  useSeo({
    title: "Services — Nanny Poppins UAE",
    description:
      "What Nanny Poppins offers: considered nanny matching for UAE families, live-in and live-out, for children of all ages.",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Services"
        title="Focused entirely on childcare."
        intro="We do one thing, and we try to do it well: help families find the right nanny. We are not a general staffing or household-services company."
      />

      <Section>
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="rounded-2xl border border-[#0B0A08]/10 bg-white p-10">
            <h2 className="font-serif text-2xl tracking-tight">What we help with</h2>
            <ul className="mt-6 space-y-4">
              {INCLUDED.map((item) => (
                <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#0B0A08]/80">
                  <Check className="mt-0.5 h-5 w-5 shrink-0 text-[#C6A04A]" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl border border-[#0B0A08]/10 bg-white p-10">
            <h2 className="font-serif text-2xl tracking-tight">What we don't do</h2>
            <ul className="mt-6 space-y-4">
              {NOT_INCLUDED.map((item) => (
                <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#0B0A08]/60">
                  <X className="mt-0.5 h-5 w-5 shrink-0 text-[#0B0A08]/40" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-2xl bg-[#0B0A08] p-10 text-[#F7F4ED] md:p-12">
          <h3 className="font-serif text-2xl tracking-tight">A note on fees</h3>
          <p className="mt-4 max-w-2xl leading-relaxed text-[#F7F4ED]/75">
            We don't publish standard prices, because every family's situation is different. The team will
            discuss fees after understanding the family's needs.
          </p>
        </div>
      </Section>

      <CTABanner />
    </div>
  );
}
